import Axios from 'axios';
import { FILTER_REGION_NAME, FILTER_ZIP_AND_COMMUNITY, getRegionByZipcode } from './filters';

export function isLocationAPIAvailable() {
  return !!navigator.geolocation;
}

export function getUsersZipcode(onZipReturned, onError) {
  const callback = function (lat, lng) {
    getZipcodeByGoogle(lat, lng, onZipReturned, onError);
  };
  getLocation(callback, onError);
}

export function filterObjectsByLocation(filtersNeeded, allRegions, filterCallback, errorCallback) {
  getUsersZipcode(zipcode => {
    const filters = {};
    const region = getRegionByZipcode(zipcode, allRegions);
    if (region) {
      if (filtersNeeded.includes(FILTER_ZIP_AND_COMMUNITY)) {
        filters[FILTER_ZIP_AND_COMMUNITY] = `${zipcode}_${region.community}`;
      }
      if (filtersNeeded.includes(FILTER_REGION_NAME)) {
        filters[FILTER_REGION_NAME] = region.name;
      }

      filterCallback(filters);
    }
  }, errorCallback);
}

function getLocation(callback, errorCallback) {
  if (isLocationAPIAvailable()) {
    navigator.geolocation.getCurrentPosition(
      position => {
        if (typeof callback === 'function') {
          callback(position.coords.latitude, position.coords.longitude);
        }
      },
      error => {
        if (typeof errorCallback === 'function') {
          errorCallback();
        }
        console.log(error);
      },
      { timeout: 10000 }
    );
  } else {
    if (typeof errorCallback === 'function') {
      errorCallback();
    }
  }
}

function getZipcodeByGoogle(lat, lng, onZipReturned, onError) {
  Axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyDr98zcRfbw8v_xqlEripJfLeuiJwaz4aA&language=en`
  ).then(res => {
    if (res.data.results && res.data.results.length) {
      for (const address of res.data.results) {
        let zipcode;
        for (const component of address.address_components) {
          if (component.types.indexOf('postal_code') >= 0) {
            zipcode = component.short_name;
          }
        }
        if (zipcode && typeof onZipReturned === 'function') {
          onZipReturned(zipcode);
          return;
        }
      }
    }
    if (typeof onError === 'function') {
      onError();
      return;
    }
  });
}
